import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Nav.css';

export class Nav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navOpen: false
        };
    }
    render() {
        let baseClass = 'nav-options';
        if (this.state.navOpen) {
            baseClass += ' open';
        }

        return (
            <div className="navigation">
                <div className="navigation-content">

                    <div className="logo-content">
                        <Link className="logo" to="/" />
                    </div>

                    <div className="menu-button" onClick={() => this.toggleMenu()}>
                        <div className="nav-icon-container">
                            <div id="nav-icon3">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>

                    <div className={baseClass}>
                        <ul>
                            <li><Link to="/conduct">Code of Conduct</Link></li>
                            <li><Link to="/contributing">How to Contribute</Link></li>
                        </ul>

                        <div className="hollow-button-container">
                            <a className="hollow-button" target="_blank" rel="noopener noreferrer" href="https://www.usaa.com">USAA.com</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    toggleMenu() {
        this.setState({
            navOpen: !this.state.navOpen
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Nav.js